import React, { Component } from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { Link } from 'react-router-dom';
import ReactTable from 'react-table';
import CompanyContext from '../../../auth/CompanyContext';
class LandingMyFavorites extends Component {
  static contextType = CompanyContext;

  constructor(props) {
    super(props);
    this.state = {
      favorites: [],
      isLoading: false
    }
  }

  componentDidMount = () => {
    this.getFavorites();
  };

  getFavorites = () => {
    this.setState({
      isLoading: true
    },() => {
      fetch('/api/favorites/' + this.props.user, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.props.clientToken,
          'X-Database': this.context.company
        }
      })
        .then(results => results.json())
        .then(results => {
          if ("data" in results) {
            this.setState({
              favorites: results.data,
              isLoading: false
            })
          }
        });
    })
  }

  render() {
    const combinedFavorites = [
      ...(this.state.favorites?.sec || []).map(item => ({ ...item, source: 'sec' })),
      ...(this.state.favorites?.contact || []).map(item => ({ ...item, source: 'contact' }))
    ];
    return (
      <Card className='w-100 m-0'>
        <CardHeader className="d-flex justify-content-between align-items-center">
          <h4>My Favorites</h4>
          {this.props.icon}
        </CardHeader>
        <CardBody className='p-0'>
          <ReactTable
            data={combinedFavorites}
            loading={this.state.isLoading}
            columns={[
              {
                Header: 'Name',
                accessor: 'Company',
                filterable: true,
                headerStyle: { textAlign: 'left' },
                Cell: row => {
                  const displayText = row.original.Company || row.original.Name || row.original.ContactName || row.original.Favorite;
                  const path = row.original.source === 'sec'
                    ? `/demographics/${row.original.Favorite}`
                    : `/contacts/${row.original.Favorite}`;
                  return <Link to={{ pathname: path }}>{displayText}</Link>;
                }
              },
              {
                Header: 'Type',
                accessor: 'source',
                headerStyle: { textAlign: 'left' },
                Cell: row => row.original.source === 'sec' ? 'Company' : 'Contact'
              }
            ]}
            pageSize={this.props.pageSize}
            onPageSizeChange={this.props.setPageSize}
            showPagination={true}
            defaultFilterMethod={this.props.filterCaseInsensitive}
          />
        </CardBody>
      </Card>
    );

  }
}

export default LandingMyFavorites;
